import { IconMainMenuHelp } from "@suse-o11y/icons";
import React from "react";

import { MainMenuItemLayout } from "./MainMenuItemLayout";

export const MainMenuItemHelp: React.FC = () => (
	<MainMenuItemLayout
		className="no-underline"
		href="https://docs.stackstate.com/"
		icon={<IconMainMenuHelp height={18} width={18} />}
		label="Help"
	/>
);
